import React, { useEffect, useRef } from 'react';
// styles
import './ZohoHelpButton.css';

const ZOHO_SCRIPT_ID = 'zohodeskasapscript';

function ZohoHelpButton() {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!document.getElementById(ZOHO_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = ZOHO_SCRIPT_ID;
      script.defer = true;
      script.src = 'https://desk.zoho.com/portal/api/web/asapApp/1076712000000539043?orgId=876064420';
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(script, firstScript);
    }

    // Cleanup Zoho Desk on unmount or route change
    return () => {
      const script = document.getElementById(ZOHO_SCRIPT_ID);
      if (script && script.parentNode) script.parentNode.removeChild(script);

      const zohoBtn = document.getElementById('zohohc-asap-web-app-main');
      if (zohoBtn && zohoBtn.parentNode) zohoBtn.parentNode.removeChild(zohoBtn);

      delete window.ZohoDeskAsapReady;
      delete window.ZohoDeskAsap__asyncalls;
      delete window.ZohoDeskAsapReadyStatus;
    };
  }, []);

  return <div ref={ containerRef } />;
}

export default ZohoHelpButton;
